"use client";

import Link from "next/link";
import { FeatheredScrollContainer } from "@/components/atoms/feathered-scroll-container";
import { useLocalizedHref, useLogicalPathname } from "@/lib/l10n/providers";
import type { LegalNavFixture } from "../types";

interface LegalSidebarProps {
  navigation: LegalNavFixture;
}

export function LegalSidebar({ navigation }: LegalSidebarProps) {
  const pathname = useLogicalPathname();
  const localizeHref = useLocalizedHref();

  return (
    <nav aria-label="Legal pages navigation">
      <FeatheredScrollContainer
        scrollDirection="vertical"
        className="max-h-[calc(100vh-8rem)]"
      >
        <ul className="space-y-1">
          {navigation.sections.map((section) => {
            const isActive = pathname === section.url;

            return (
              <li key={section.url}>
                <Link
                  href={localizeHref(section.url)}
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "instant" })
                  }
                  className={`text-body-lg font-sans! block rounded px-3 py-1.5 transition-colors ${
                    isActive
                      ? "bg-chalk font-medium text-black"
                      : "hover:bg-off-white text-black/60 hover:text-black"
                  }`}
                >
                  {section.title}
                </Link>

                {isActive && section.menuItems.length > 0 && (
                  <ul className="ml-4 mt-1 space-y-0.5 border-l border-black/10 pl-3">
                    {section.menuItems.map((item) => (
                      <li key={item.url}>
                        <a
                          href={localizeHref(item.url)}
                          className="font-sans! text-body block py-0.5 text-black/50 hover:text-black/70"
                        >
                          {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </FeatheredScrollContainer>
    </nav>
  );
}
